// store/socketStore.ts
import { create } from "zustand";
import { persist } from "zustand/middleware";

type Message = {
    message: string;
    from: string;
    products?: Product[];
    categories?: Category[];
    isProactive?: boolean;
    proactiveDelay?: number;
};

type Product = {
    category: string;
    description: string;
    id: string;
    image_url: string;
    name: string;
    price: number;
    product_url: string;
};

type Category = {
    description: string;
    id: string;
    image_url: string;
    name: string;
    url: string;
};

interface MessageState {
    sessionId: string;
    messages: Message[];
    setMessages: (messages: Message[]) => void;
    setSessionId: (sessionId: string) => void;
}

const useMessageData = create<MessageState>()(
    persist(
        (set) => ({
            sessionId: "",
            messages: [],
            setSessionId: (sessionId) => set(() => ({ sessionId })),
            setMessages: (messages) => set(() => ({ messages: Array.isArray(messages) ? messages : [] })),
        }),
        {
            name: "message-data", // Key in localStorage
            partialize: (state) => ({
                sessionId: state.sessionId,
                messages: Array.isArray(state.messages) ? state.messages : [],
            }),
        }
    )
);

export default useMessageData;
